{
  "newCampaign": "Nouvelle campagne",
  "firmware": {
    "update": {
      "label": "Mise à jour du firmware",
      "description": "Paramétrer la date et l'heure de la procédure de lancement de la mise à jour du firmware de l'{name}",
      "firmwareLabel": "Firmware",
      "uuidRequired": "Le firmware est obligatoire",
      "plannedStartAt": "Date de mise à jour du firmware (JJ/MM/AAAA HH:MM)",
      "notaBene": "La mise à jour du firmware sera effectuée lors de la prochaine communication avec l'{name} à partir de la date de mise à jour du firmware.",
      "dateTimeError": "Le champ date est requis pour la mise à jour du firmware",
      "firmwareSelection": "Sélectionnez un firmware dans la liste ci-dessous",
      "FirmwareSelectionRequired": "Vous devez sélectionner un firmware dans la liste",
      "warningMessage": "Attention: La mise à jour du firmware entraînera un redémarrage des équipements concernés à la fin de la mise à jour."
    }
  },
  "dateInferiorToToday": "La date ne doit pas être inférieure à la date/heure actuelle",
  "dateInferiorToDate": "La date ne doit pas être inférieure au {date}",
  "dateFormat": "DD/MM/YYYY HH:mm",
  "confirm": "Confirmer",
  "cancel": "Annuler",
  "list": {
    "column": {
      "name": {
        "label": "Campagne"
      },
      "type": {
        "label": "Type",
        "CRTCLT_RENEWAL_DVC": "Renouvellement de certificats d'équipements",
        "CRTCLT_RENEWAL_APP": "Renouvellement de certificats d'applicatifs",
        "FIRMWARE_UPGRADE_DVC": "Mise à jour de firmwares d'équipements"
      },
      "dates": {
        "label": "Dates",
        "format": "DD/MM/YYYY"
      },
      "numberOfEquipments": {
        "label": "Nombre d'équipements",
        "value": "{count} équipement | {count} équipement | {count} équipements"
      },
      "status": {
        "label": "Statut",
        "value": {
          "SCHEDULED": "Planifié",
          "RUNNING": "En cours",
          "PAUSED": "En pause",
          "COMPLETE": "Terminé",
          "COMPLETE_WITH_ERRORS": "Terminé avec erreurs",
          "INCOMPLETE": "Incomplète",
          "PLATFORM_ERROR": "Erreur",
          "CANCELLING": "Annulation",
          "CANCELLED": "Annulé",
          "UNKNOWN": "Inconnu",
          "DRAFT": "Brouillon"
        }
      },
      "pending": {
        "label": "En attente"
      },
      "inProgress": {
        "label": "En cours"
      },
      "success": {
        "label": "Succès"
      },
      "failed": {
        "label": "Échoué"
      },
      "numberOfDevice": {
        "label": "Nombre d'équipements",
        "value": "{count} équipement | {count} équipement | {count} équipements"
      },
      "operations": "Opérations",
      "done": {
        "label": "Terminée"
      }
    },
    "empty": "Aucune campagne n'a été trouvée"
  },
  "details": {
    "buttons": {
      "update": {
        "label": "Modifier"
      },
      "cancel": {
        "label": "Annuler la campagne",
        "confirm": {
          "message": "Confirmer l'annulation de la campagne ?",
          "title": "Annuler la campagne",
          "yes": "Oui",
          "no": "Non"
        }
      },
      "edit": {
        "label": "Editer"
      }
    },
    "properties": {
      "title": "Propriétés",
      "name": {
        "label": "Nom"
      },
      "type": {
        "label": "Type",
        "CRTCLT_RENEWAL_DVC": "Renouvellement de certificats d'équipements",
        "CRTCLT_RENEWAL_APP": "Renouvellement de certificats d'applicatifs",
        "FIRMWARE_UPGRADE_DVC": "Mise à jour de firmwares d'équipements"
      },
      "dates": {
        "label": "Dates"
      },
      "state": {
        "label": "Statut"
      }
    },
    "characteristics": {
      "title": "Caractéristiques",
      "createdBy": "Créé par",
      "type": {
        "label": "Type :",
        "value": {
          "CRTCLT_RENEWAL_DVC": "Renouvellement de certificats d'équipements",
          "CRTCLT_RENEWAL_APP": "Renouvellement de certificats d'applicatifs",
          "FIRMWARE_UPGRADE_DVC": "Mise à jour de firmwares d'équipements"
        }
      },
      "status": {
        "label": "Statut :",
        "value": {
          "SCHEDULED": "Planifié",
          "RUNNING": "En cours",
          "PAUSED": "En pause",
          "COMPLETE": "Terminé",
          "COMPLETE_WITH_ERRORS": "Échec",
          "INCOMPLETE": "Échec",
          "PLATFORM_ERROR": "Erreur",
          "CANCELLING": "Annulation",
          "CANCELLED": "Annulé"
        }
      },
      "lifeCyle": {
        "creation": "Création : {value}",
        "launch": "Lancement : {value}",
        "closing": "Fermeture : {value}"
      },
      "inclusionPeriods": {
        "title": "Périodes d'inclusion",
        "inactive": "inactive",
        "monday": "Lundi : {value}",
        "tuesday": "Mardi : {value}",
        "wednesday": "Mercredi : {value}",
        "thursday": "Jeudi : {value}",
        "friday": "Vendredi : {value}",
        "saturday": "Samedi : {value}",
        "sunday": "Dimanche : {value}"
      },
      "equipments": {
        "title": "{count} équipement | {count} équipement | {count} équipements",
        "status": {
          "pending": "En attente : {percent}, {count} équipement | En attente : {percent}, {count} équipement | En attente : {percent}, {count} équipements",
          "running": "En cours : {percent}, {count} équipement | En cours : {percent}, {count} équipement | En cours : {percent}, {count} équipements",
          "complete": "Succès : {percent}, {count} équipement | Succès : {percent}, {count} équipement | Succès : {percent}, {count} équipements",
          "failed": "Échouée : {percent}, {count} équipement | Échouée : {percent}, {count} équipement | Échouée : {percent}, {count} équipements"
        },
        "statistics": {
          "title": "{count} équipement | {count} équipement | {count} équipements"
        }
      },
      "devices": {
        "status": {
          "scheduled": "Planifié : {percent}, {count} équipement | Planifié : {percent}, {count} équipement | Planifié : {percent}, {count} équipements",
          "completed": "Terminé : {percent}, {count} équipement | Terminé : {percent}, {count} équipement | Terminé : {percent}, {count} équipements",
          "error": "Erreur : {percent}, {count} équipement | Erreur : {percent}, {count} équipement | Erreur : {percent}, {count} équipements",
          "running": "En cours : {percent}, {count} équipement | En cours : {percent}, {count} équipement | En cours : {percent}, {count} équipements"
        }
      },
      "operationType": "Type :"
    },
    "equipments": {
      "title": "Liste des équipements",
      "column": {
        "label": {
          "label": "Équipement"
        },
        "deviceType": {
          "label": "Type d'équipement"
        },
        "message": {
          "label": "État de l'opération"
        },
        "startDate": {
          "label": "Date de démarrage de l'opération",
          "format": "DD/MM/YYYY HH:mm"
        },
        "lastOperationDate": {
          "label": "Date de la dernière opération",
          "format": "DD/MM/YYYY HH:mm"
        },
        "name": {
          "label": "Nom"
        },
        "serialNumber": {
          "label": "Numéro de série"
        },
        "firmware": {
          "label": "Firmware"
        },
        "connectivity": {
          "label": "Connectivité"
        },
        "metastatus": {
          "label": "Metastatus"
        },
        "sector": {
          "label": "Secteur"
        },
        "lastUpdate": {
          "label": "Date de dernière mise à jour"
        },
        "operationStatus": {
          "label": "Statut de l'opération"
        }
      },
      "empty": "Aucun équipement n'a été trouvé",
      "states": {
        "WITHDRAWN": "Retiré",
        "DEACTIVATED": "Désactivé",
        "DELETED": "Supprimé"
      }
    },
    "status": {
      "title": "Statut de la campagne"
    },
    "cancel": {
      "error": "Une erreur est survenue pendant l’annulation de la campagne.",
      "success": "L’annulation de la campagne a été déclenchée avec succès."
    }
  },
  "form": {
    "campaignSettings": {
      "title": "Paramétrage de la campagne",
      "name": "Nom de la campagne",
      "typeOfCampaign": {
        "title": "Type de la campagne",
        "firmwareUpdate": {
          "title": "Campagne de mise à jour du firmware",
          "option": "Mise à jour de firmwares d'équipements",
          "label": "Nom du firmware",
          "dependencies": "Dépendances"
        },
        "deviceCertificateRenewal": "Renouvellement de certificats d'équipements",
        "applicationCertificateRenewal": "Renouvellement de certificats d'applicatifs"
      },
      "validation": {
        "name": "Le nom de la campagne est obligatoire",
        "type": "Le type de la campagne est obligatoire",
        "firmwareUuid": "Le firmware est obligatoire"
      }
    },
    "fleetSelection": {
      "title": "Sélection de la flotte d'équipements",
      "devices": "Équipements",
      "applications": "Applicatifs",
      "validation": {
        "required": "La sélection d'au moins un équipement est obligatoire"
      },
      "actions": {
        "scheduled": {
          "confirm": {
            "title": "Actions en cours existantes",
            "message": "Certains équipements sélectionnés possèdent déjà des actions en cours. Continuer ?",
            "yes": "Oui",
            "no": "Non"
          }
        }
      }
    },
    "campaignPlanification": {
      "title": "Planification de la campagne",
      "executionDates": {
        "title": "Dates d'exécution de la campagne",
        "plannedStartAt": "Début de la campagne",
        "endDate": "Fin de la campagne",
        "validation": {
          "plannedStartAt": "La date de début de la campagne est obligatoire",
          "plannedEndAt": "La date de fin de la campagne est obligatoire",
          "startDateNotBeyondLicenseExpirationDateTolerancy": "La date de lancement de la campagne ne peut être postérieure à la date d'expiration de la licence",
          "endDateNotBeyondLicenseExpirationDateTolerancy": "La date de fin de la campagne ne peut être postérieure à la date d'expiration de la licence"
        }
      },
      "inclusionPeriods": {
        "title": "Périodes d'inclusion",
        "remove": "Supprimer",
        "add": "Ajouter",
        "day": "Jour",
        "days": {
          "monday": "lundi",
          "tuesday": "mardi",
          "wednesday": "mercredi",
          "thursday": "jeudi",
          "friday": "vendredi",
          "saturday": "samedi",
          "sunday": "dimanche"
        },
        "validation": {
          "day": "Le jour de la période d'inclusion est obligatoire",
          "range": "La durée d'une période d'inclusion ne peut être inférieure à 15 minutes"
        }
      }
    },
    "buttons": {
      "next": "Suivant",
      "previous": "Précédent",
      "submit": "Valider"
    }
  },
  "report": {
    "title": "Rapport",
    "plannedStartAt": "Date de lancement prévue :",
    "processes": {
      "column": {
        "label": "Nom",
        "status": "Statut"
      }
    }
  },
  "funnel": {
    "step": "Etape",
    "of": "de",
    "newCampaign": "Paramétrer une nouvelle campagne",
    "updateCampaign": "Editer la campagne",
    "scheduling": "Planification",
    "next": "Suivant",
    "previous": "Précédent",
    "publish": "Publier la campagne",
    "campaignSettings": {
      "title": "Choisir les paramètres",
      "name": "Nom de la campagne",
      "typeOfCampaign": {
        "title": "Type de campagne",
        "firmwareUpdate": {
          "label": "Mise à jour du firmware",
          "title": "Campagne de mise à jour du firmware",
          "firmwareName": "Nom du firmware"
        },
        "certificate": "Certificat",
        "deviceCertificateRenewal": "Renouvellement de certificats d'équipements",
        "applicationCertificateRenewal": "Renouvellement de certificats d'applicatifs",
        "configurationUpdate": {
          "selfSupporting": {
            "warningMessage": "Cette campagne appliquera la configuration la plus récente à chacun des appareils sélectionnés."
          }
        }
      },
      "validation": {
        "name": "Le nom de la campagne est obligatoire",
        "type": "Le type de la campagne est obligatoire",
        "firmwareUuid": "Le firmware est obligatoire"
      },
      "operationModelType": {
        "CONFIG": "Configuration",
        "FIRM_UPDATE": "Mise à jour de firmware",
        "OPTIONS": "Options",
        "CERT_RENEW": "Renouvellement de certificat"
      }
    },
    "fleetSelection": {
      "title": "Flotte d'équipements",
      "validation": {
        "required": "La sélection d'au moins un équipement est obligatoire"
      },
      "actions": {
        "scheduled": {
          "confirm": {
            "title": "Actions en cours existantes",
            "message": "Certains équipements sélectionnés possèdent déjà des actions en cours. Continuer ?",
            "yes": "Oui",
            "no": "Non"
          }
        }
      },
      "devices": "Équipements",
      "fleets": "Flottes",
      "fleetInformation": {
        "title": "Informations sur {fleetName}",
        "message": {
          "beginning": "Avec la configuration actuelle de la campagne,",
          "middle": "{count} équipement de la flotte | {count} équipement de la flotte | {count} équipements de la flotte",
          "end": "ne pourra pas être mis à jour | ne pourra pas être mis à jour | ne pourront pas être mis à jour"
        }
      }
    },
    "campaignPlanification": {
      "title": "Choisissez les dates",
      "executionDates": {
        "plannedStartAt": "Début de la campagne",
        "endDate": "Fin de la campagne",
        "validation": {
          "plannedStartAt": "La date de début de la campagne est obligatoire",
          "startDateNotBeyondLicenseExpirationDateTolerancy": "La date de lancement de la campagne ne peut être postérieure à la date d'expiration de la licence",
          "endDateNotBeyondLicenseExpirationDateTolerancy": "La date de fin de la campagne ne peut être postérieure à la date d'expiration de la licence",
          "plannedEndAt": "La date de fin de la campagne est obligatoire"
        }
      },
      "inclusionPeriods": {
        "title": "Périodes d'inclusion",
        "subTitle": "Optionnel",
        "informations": {
          "period": "C'est une période durant laquelle un équipement est autorisé à exécuter une action.",
          "defaultValue": "Par défaut, aucune restriction ne sera appliquée à l'équipement.",
          "businessHour": "Horaires de bureau (lundi au vendredi - 09h00 à 18h00)",
          "weekendHour": "Weekend (samedi au dimanche - 00h00 à 23h59)"
        },
        "days": {
          "monday": "lundi",
          "tuesday": "mardi",
          "wednesday": "mercredi",
          "thursday": "jeudi",
          "friday": "vendredi",
          "saturday": "samedi",
          "sunday": "dimanche"
        },
        "addADay": "Ajouter un jour",
        "add": "Ajouter",
        "delete": "Supprimer",
        "selectPlaceholder": "Sélectionnez un jour",
        "start": "Début",
        "end": "Fin",
        "validation": {
          "day": "Le jour de la période d'inclusion est obligatoire",
          "start": "Le début de la période d'inclusion est obligatoire",
          "end": "La fin de la période d'inclusion est obligatoire",
          "range": "La durée d'une période d'inclusion ne peut être inférieure à 15 minutes",
          "startAfterEnd": "L'heure de début ne peut être postérieure à la l'heure de fin",
          "endBeforeStart": "L'heure de fin ne peut être antérieure à la l'heure de début"
        },
        "presets": {
          "businessHours": "Heures ouvrables (lundi au vendredi - 9h00 à 18h00)",
          "weekend": "Week-ends (samedi au dimanche - 00h00 à 23h59)"
        }
      }
    },
    "deviceFleetSelection": {
      "title": "Flotte d'équipements"
    }
  },
  "operationModelType": {
    "composite": "Composite"
  },
  "operationMgr": {
    "filters": {
      "status": "Statut",
      "type": "Type"
    }
  }
}
